"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import RecruitApiClient from "../../RecruitApiClient";
class Api {
  constructor() {
    this.getSearches = (page = 1, limit = 20, sort = "id", sortOrder = "desc", query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort,
        sort_order: sortOrder
      });
      if (query) {
        params.append("query", query);
      }
      return RecruitApiClient.get(`/api/v4/candidate_sourcing/searches?${params.toString()}`);
    };
    this.getCandidatePools = (page = 1, limit = 20, sort = "id", sortOrder = "desc", query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort,
        sort_order: sortOrder
      });
      if (query) {
        params.append("query", query);
      }
      return RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools?${params.toString()}`);
    };
    this.getCandidatePool = (id) => RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools/${id}`);
    this.updateCandidatePool = (id, data) => RecruitApiClient.put(`/api/v4/candidate_sourcing/candidate_pools/${id}`, data);
    this.getCandidatePoolCandidateGroups = (poolId, page = 1, limit = 20, sort = "id", sortOrder = "desc", query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        sort,
        sort_order: sortOrder
      });
      if (query) {
        params.append("q", query);
      }
      return RecruitApiClient.get(
        `/api/v4/candidate_sourcing/candidate_pools/${poolId}/candidate_groups?${params.toString()}`
      );
    };
    this.getCandidatePoolEmailBatches = (poolId, page = 1, limit = 20, query) => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      if (query) {
        params.append("q[search]", query);
      }
      return RecruitApiClient.get(
        `/api/v4/candidate_sourcing/candidate_pools/${poolId}/email_batches?${params.toString()}`
      );
    };
    this.getCandidatePoolEmailBatchDetails = (poolId, emailBatchId) => RecruitApiClient.get(
      `/api/v4/candidate_sourcing/candidate_pools/${poolId}/email_batches/${emailBatchId}`
    );
    this.deleteSearch = (id) => RecruitApiClient.delete(`/api/v4/candidate_sourcing/searches/${id}`);
    this.deleteCandidatePool = (id) => RecruitApiClient.delete(`/api/v4/candidate_sourcing/candidate_pools/${id}`);
    this.bulkEmailCandidateSourcingPools = (candidateSourcingPoolIds, emailData) => {
      const payload = {
        email_batch: __spreadValues({
          candidate_sourcing_pool_ids: candidateSourcingPoolIds
        }, emailData)
      };
      return RecruitApiClient.post("/api/v4/candidate_sourcing/candidate_pools/bulk_email", payload);
    };
    this.getEmailTemplates = () => RecruitApiClient.get("/api/v4/searches/email_templates?group_templates=true");
    this.getEmailTemplateDetails = (id) => RecruitApiClient.get(`/api/v4/searches/email_templates/${id}`);
  }
}
export default new Api();
